export function hasStrikethroughPrice(price?: number, msrp?: number): boolean {
  if (typeof price === 'undefined' || typeof msrp === 'undefined') return false;
  return price < msrp;
}
